import React from "react";
import { Button, Icon, Modal } from "semantic-ui-react";

export interface ModalMakeAppointmentErrorProps {
  open: boolean;
  title?: string;
  subtitle?: string;
  iconSrc?: string;
  buttonText?: string;
  onClose: () => void;
}

/**
 * Reusable error modal component with customizable content
 * Displays an error message with an icon, title, subtitle, and close button
 */
const ModalMakeAppointmentError: React.FC<ModalMakeAppointmentErrorProps> = (props) => {
  const {
    open,
    title = "เกิดข้อผิดพลาด",
    subtitle,
    iconSrc = "/static/images/schedule/calendar-error-icon.png",
    buttonText = "ปิดหน้าต่าง",
    onClose,
  } = props;

  return (
    <Modal
      style={{
        border: "1px solid rgba(243, 130, 160, 1)",
        borderRadius: "12px",
      }}
      open={open}
      size="tiny"
      closeOnDimmerClick
      onClose={onClose}
    >
      <div style={{ padding: "1rem" }}>
        {/* Close button */}
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginBottom: "0.5rem",
          }}
        >
          <Icon
            style={{
              color: "rgba(79, 79, 79, 1)",
              fontSize: "1.2rem",
              margin: 0,
            }}
            name="close"
            link
            onClick={onClose}
          />
        </div>

        {/* Error icon */}
        <div style={{ margin: "2.5rem 0 1.5rem", textAlign: "center" }}>
          <img
            style={{ width: "130px" }}
            alt="error-icon"
            src={iconSrc}
          />
        </div>

        {/* Error message */}
        <div style={{ marginBottom: "2rem", textAlign: "center" }}>
          <h3
            style={{
              color: "rgba(243, 130, 160, 1)",
              fontSize: "1.3rem",
              fontWeight: "600",
              marginBottom: "0.75rem",
            }}
          >
            {title}
          </h3>
          {subtitle && (
            <p
              style={{
                color: "rgba(79, 79, 79, 1)",
                fontSize: "1.2rem",
                margin: 0,
              }}
            >
              {subtitle}
            </p>
          )}
        </div>

        {/* Close button */}
        <div style={{ textAlign: "center" }}>
          <Button
            style={{
              backgroundColor: "rgba(200, 200, 200, 1)",
              borderRadius: "6px",
              fontSize: "1rem",
              marginBottom: "1rem",
            }}
            onClick={onClose}
          >
            {buttonText}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ModalMakeAppointmentError;
